/**
 * Marca oficial da Personalitec — paths e cores exatos do logo (mesma fonte do site institucional, src/logoPaths.ts).
 * Cores da marca são fixas: não seguem tema nem acento do cliente.
 */
export const LOGO_VIEWBOX = '90 0 900 1080';

export const PARTES_LOGO: { d: string; fill: string }[] = [
  { d: 'M639.9 20.7h319.5l-679 679.1L120.6 540z', fill: '#39cefd' },
  { d: 'M360.3 779.7L520 939.5 959.4 500H639.9z', fill: '#39cefd' },
  { d: 'M360.282 779.645L520.086 619.84 679.9 779.645 520.086 939.45z', fill: '#16b9fd' },
  { d: 'M520 939.5l119.9 119.8h319.5L679.8 779.7z', fill: '#03569b' },
  { d: 'M757 857.4l-77.2-77.7L520 939.5z', fill: 'rgba(26,35,126,0.35)' },
];

export function LogoPersonalitec({ tamanho = 28, titulo }: { tamanho?: number; titulo?: string }) {
  return (
    <svg viewBox={LOGO_VIEWBOX} width={tamanho * (900 / 1080)} height={tamanho} role={titulo ? 'img' : undefined}
      aria-label={titulo} aria-hidden={titulo ? undefined : true}>
      {PARTES_LOGO.map((p) => <path key={p.d} d={p.d} fill={p.fill} />)}
    </svg>
  );
}
